module.exports = __webpack_public_path__ + "static/media/icon-app-light.b71beb4b.svg";